import { render, staticRenderFns } from "./SwitchBlock.vue?vue&type=template&id=3c0cfb54&"
import script from "./SwitchBlock.vue?vue&type=script&lang=js&"
export * from "./SwitchBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports